var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutomate = function SvgAutomate(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-20": 12,
    "data-width-24": 14,
    viewBox: "0 0 13.5 21.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m.7 12.7 7-12v8h5l-7 12v-8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutomate);
export default ForwardRef;